class statisticsSalesRankListCtrl {
    constructor($scope, httpRequest, $state, treeSelectService) {
        // 存储页面信息
        $scope.pageState = {
            idToken: localStorage.id_token,
            userInfo: JSON.parse(localStorage.user_info),
        }
        // 字典数据
        $scope.dictData = {}
        $scope.dictData.cancel_status = [
            { enumTypeCode: null, enumName: '正常', enumCode: '0' },
            { enumTypeCode: null, enumName: '已作废', enumCode: '1' },
        ]
        const typecodeArr = ['inv_type', 'invoice_status', 'is_red']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        // 下拉销方
        $scope.querySaleConfig = {
            queryName: 'saleName',
            queryKey: 'saleId',
            queryType: 'Flater',
            parentIdName: 'parentSaleId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }

        $scope.reset = function () {
            $scope.param = {
                param: {
                    invoiceType: '',
                    invoiceDateEnd: initDate(),
                    invoiceDateBegin: initDate(),
                    rank: '10',
                    saleName: '',
                    accessToken: $scope.pageState.idToken,
                    saleCreditCode: '',
                },
            }
            $scope.querySaleConfig.defaultSelect = []
        }
        $scope.reset()
        $scope.getDetailParam = {}
        let orgIdArr = []
        $scope.rankList = [
            {
                name: '前十',
                value: 10,
            },
            {
                name: '前二十',
                value: 20,
            },
            {
                name: '前五十',
                value: 50,
            },
        ]
        $scope.datePickerConfig = {
            format: 'yyyy-mm',
            minView: 3,
            startView: 3,
        }

        $scope.saleList = [] // 销方
        // 更新时间
        $scope.total = {
            companyNum: 0,
            totalTurnOver: 0,
        }


        httpRequest.get_getUserOrgList().then(
            (res) => {
                orgIdArr = res.data.value.map((item) => item.orgId)
                getSaleInfo()
            },
        )
        function getSaleInfo() {
            httpRequest.post_getSaleInfoListByOrgIds(orgIdArr).then(
                (res) => {
                    $scope.saleList = treeSelectService(res.data, 'saleId', 'saleName')
                    queryInfo()
                },
            )
        }

        // 时间格式初始化
        function initDate(month, year, day) {
            const date = new Date()
            let y = year || date.getFullYear()
            let m = month || date.getMonth()
            if (m === 0) {
                y -= 1
                m = 12
            }
            m = m < 10 ? `0${m}` : m
            return `${y}-${m}`
        }

        // let isSearch = false
        // $scope.$watch('param', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('statistics.outputStatistics.statisticsSalesRank') != -1) {
        //         isSearch && sessionStorage.setItem('salesParam', JSON.stringify($scope.param))
        //     }
        // })

        function queryInfo() {
            $scope.param = sessionStorage.salesParam ? JSON.parse(sessionStorage.salesParam) : $scope.param
            $scope.getDetailParam = JSON.parse(JSON.stringify($scope.param.param))
            httpRequest.post_selectTotalSale($scope.param.param).then((res) => {
                if (res.data.success) {
                    $scope.total.companyNum = res.data.value.companyNum || 0
                    $scope.total.totalTurnOver = res.data.value.totalTurnOver || 0
                }
            })
            httpRequest.post_selectSaleRanking($scope.param.param).then((res) => {
                $scope.listData = res.data.value
                $scope.param.pageNum = res.data.value.pageNum
            })
        }

        // 销方变化
        $scope.saleSelectChange = function (v) {
            const saleSelectArr = v
            const saleSelectL = saleSelectArr.length
            if (saleSelectL > 0) {
                $scope.param.param.saleName = saleSelectArr.map((item) => item.saleName).join()
                $scope.param.param.saleCreditCode = saleSelectArr.map((item) => item.saleCreditCode).join()
            } else {
                $scope.param.param.saleName = ''
                $scope.param.param.saleCreditCode = ''
            }
        }

        // 导出
        $scope.exportInvoic = function () {
            httpRequest.get_exportSaleRanking($scope.param.param)
        }

        // 详情
        $scope.toDetailPage = function (item) {
            const temp = JSON.parse(JSON.stringify(item))
            temp.invoiceDateBegin = $scope.getDetailParam.invoiceDateBegin
            temp.invoiceDateEnd = $scope.getDetailParam.invoiceDateEnd
            temp.invoiceType = $scope.getDetailParam.invoiceType
            temp.saleName = $scope.getDetailParam.saleName
            temp.saleCreditCode = $scope.getDetailParam.saleCreditCode
            $state.go(
                'statistics.outputStatistics.statisticsSalesRank.detail',
                {
                    params: JSON.stringify(temp),
                },
            )
        }
        // 搜索
        $scope.searchlist = function () { // 点击搜索发起查询
            sessionStorage.setItem('salesParam', JSON.stringify($scope.param))
            queryInfo()
        }
    }
}
statisticsSalesRankListCtrl.$inject = ['$scope', 'httpRequest', '$state', 'treeSelectService']
export default statisticsSalesRankListCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsSalesRank/statisticsSalesRankListCtrl.js